import React from 'react';
import { useQuery } from 'react-query';

import { fundsRequestsApi } from 'api';
import { ExportDataButton } from 'components';
import { EntityArchiveState, QueryKey } from 'enums';
import { useMutation } from 'hooks';
import { fundsRequestUtils } from 'utils';

type Props = {
  archived: boolean;
};

export const ExportFundsRequests: React.FC<Props> = ({ archived }) => {
  const { mutate: exportFundsRequests, isLoading } = useMutation(
    fundsRequestsApi.exportFundsRequests(),
    {
      notifierType: 'none',
    },
  );

  const columnsQueryResult = useQuery(
    QueryKey.FundsRequests,
    fundsRequestsApi.getExportColumns(),
    { staleTime: Infinity },
  );

  return (
    <ExportDataButton
      tab={archived ? EntityArchiveState.Archived : EntityArchiveState.Active}
      columns={columnsQueryResult.data?.columns || []}
      isLoading={isLoading}
      labelGetter={fundsRequestUtils.getExportFundsRequestsColumnLabel}
      onExport={exportFundsRequests}
    />
  );
};
